<template>
  <div class="my_software english_container">
    <myHeader />
    <div class="bg">
      <h1 class="enProductTitle">Software Subscription</h1>
      <div class="card-container">
        <!-- :style="{
            border: card.isSelected ? '4px solid #2a82e4' : '0px solid #2a82e4',
            boxShadow: card.isSelected ? '5px 5px 20px #007bff' : 'none',
          }" -->
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="card"
          :class="{ cardActive: card.isSelected }"
          @click="selectCard(index)"
        >
          <div class="card-icon" :style="{ backgroundColor: card.bgColor }">
            {{ card.title }}
          </div>
          <div class="card-price">
            <span>{{ card.price }}</span>
            <span></span>
          </div>
          <!-- <input type="number" class="num" v-model="card.num"> -->
          <!-- <div class="card-subtext">{{ card.subtext }}</div> -->
          <!-- <button class="subscribe-btn" :class="card.btnClass" @click="MembershipSubscription(index, card.num)">立即订阅</button> -->
        </div>
      </div>
      <div class="feedback-container">
        <p>
          Please acknowledge the staff member who provided the most outstanding
          support.
        </p>
        <!-- <p>
          as this will help generate positive motivation for them and enhance
          your learning and usage experience.
        </p> -->
        <div class="input-group">
          <p>
            name:&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;<input
              type="text"
              v-model="workName"
              placeholder="Staff name (optional)"
            />
          </p>
          <p>
            number: &nbsp;<input
              type="text"
              v-model="selectedNum"
              placeholder="Please enter the order quantity"
              @input="validateInput"
            />
          </p>
          <button
            type="text"
            class="button_bor"
            :disabled="btnDisabled"
            @click="handleSubscribe"
          >
            SUBSCRIBE NOW
          </button>
        </div>
      </div>
    </div>
    <div class="bg1">
      <div>
        <h1 class="headtext wow fadeInUp">
          <!-- LOG IN TO YOUR HECOOS ACCOUNT <br />TO UNLOCK EXCLUSIVE EXPERIENCE -->
          hecoos Member Benefits
        </h1>
      </div>
      <div class="slider wow fadeInUp">
        <div
          class="slider-wrapper"
          :style="{
            transform: `translateX(-${(currentIndex * 150) / slides.length}%)`,
          }"
        >
          <div
            v-for="(slide, index) in slides"
            :key="index"
            class="slide"
            :class="{ hiddenImg: currentIndex == 0 && index == 3 }"
          >
            <img :src="slide.image" alt="slide" />
            <p>{{ slide.desc }}</p>
          </div>
        </div>
      </div>
      <div class="parents">
        <button
          class="arrow-button"
          :class="{ disableBtn: currentIndex == 0 }"
          @click="prevSlide"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <button
          class="arrow-button"
          :class="{ disableBtn: currentIndex == slides.length - 2 }"
          @click="nextSlide"
        >
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
    </div>
    <myFooter />
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader";
import myFooter from "@/components/en_pc/myFooter";
import BackToTop from "@/components/en_pc/BackToTop";
import { VipSubscribe, paypal } from "@/api/api";
import { Message } from "element-ui";

export default {
  data() {
    return {
      btnDisabled: false,
      workName: "",
      orderType: 3, //存储对应的 周月年
      staffName: "", //存储姓名
      selectedNum: 1, // 新增变量，用于存储选中卡片的数量
      cards: [
        {
          title: "Weekly",
          price: "$12.00",
          subtext: "Per week",
          btnClass: "one",
          bgColor: "#848A95 ",
          isSelected: false,
          orderType: 3,
          num: 1,
        },
        {
          title: "Monthly",
          price: "$29.00",
          subtext: "Per month",
          btnClass: "active",
          bgColor: "#147CF5",
          isSelected: false,
          orderType: 1,
          num: 1,
        },
        {
          title: "Yearly",
          price: "$299.00",
          subtext: "Per year",
          btnClass: "dark",
          bgColor: "#0B162B",
          isSelected: false,
          orderType: 2,
          num: 1,
        },
      ],
      // carouselList: [
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      // ],
      currentIndex: 0,
      slides: [
        {
          image:
            "https://download.hecoos.com/enlightv/2025-37/28b0215286c7d1e1c1907b0a918d8b81.png",
          desc: "3D Pre-Visualization, Projection Simulation, Lighting Effects Editing, and Director Design.",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-37/5b9aa1b57aec71f2b1b8d35047e0ce57.png",
          desc: "2*2K Test Signal Output (Watermarked), External Equipment Control (Intermittent Interruptions).",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-17/9c609c133d5ff2e733e08934ef8167c5.png",
          desc: "Program and Control Command Editing, Onsite Project Debugging.",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-35/02a5e47e63883b0428b059fb2ae7357b.jpg",
          desc: "As a project testing application, it can be used independently of the hecoos server",
        },
      ],
    };
  },
  created() {
    // this.MembershipSubscription()
    if (localStorage.getItem("orderMsg")) {
      const msg = JSON.parse(localStorage.getItem("orderMsg"));
      console.log(msg);
      this.cards.forEach((item, index) => {
        if (item.orderType == msg.orderType) {
          this.orderType = msg.orderType;
          item.isSelected = true;
          item.num = msg.num;
        } else {
          item.isSelected = false;
        }
      });
      this.selectedNum = msg.num;
      localStorage.removeItem("orderMsg");
      // // 重新选中年月日
      // if (msg.orderType === 3) {
      //   this.cards[0].isSelected = true;
      //   this.cards[0].num = msg.num;
      // } else if (msg.orderType === 1) {
      //   this.cards[1].isSelected = true;
      //   this.cards[1].num = msg.num;
      // } else if (index === 2) {
      //   this.cards[2].isSelected = true;
      //   this.cards[2].num = msg.num;
      // }
      // 重新赋值之前选择的数量
      // this.selectedNum = msg.num
    }
    if (this.$route.query.orderType) {
      let orderType = this.$route.query.orderType;
      this.cards.forEach((item, index) => {
        if (item.orderType == orderType) {
          this.orderType = orderType;
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }
      });
    }
  },
  watch: {
    workName(newValue) {
      console.log(newValue, "newValue");
    },

    // selectedNum(newValue, oldValue) {
    //   console.log('数量发生变化啦！旧值:', oldValue, '新值:', newValue);
    // }
  },
  components: { myHeader, myFooter, BackToTop },
  methods: {
    validateInput() {
      // 移除所有非数字字符
      let value = this.selectedNum.toString().replace(/[^0-9]/g, "");

      // 转换为数字
      let num = Number(value);

      // 处理空值情况
      if (value === "") {
        this.selectedNum = "";
        return;
      }

      // 限制范围
      if (num < 1) {
        num = 1;
      } else if (num > 99) {
        num = 99;
      }

      this.selectedNum = num;
    },
    changeStaffName(tt) {
      console.log(tt);
    },
    // 选中对应的价格
    selectCard(index) {
      this.cards.forEach((card, i) => {
        card.isSelected = i === index;
      });
      // 存储对应的数字 1, 2, 3
      if (index === 0) {
        this.orderType = 3;
      } else if (index === 1) {
        this.orderType = 1;
      } else if (index === 2) {
        this.orderType = 2;
      }
      console.log(this.orderType);
      this.selectedNum = this.cards[index].num; // 更新选中卡片的数量
      // console.log(this.selectedNum);
    },

    prevSlide() {
      if (this.currentIndex != 0) {
        this.currentIndex =
          (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      }
    },
    nextSlide() {
      if (this.currentIndex != this.slides.length - 2) {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      }
    },
    handleSubscribe() {
      const orderMsg = {
        orderType: this.orderType,
        num: this.selectedNum,
      };
      if (!this.orderType) {
        Message.error("Please select the subscription type first");
        return;
      }
      if (this.selectedNum <= 0) {
        Message.error("The subscription quantity must be greater than 0");
        return;
      }

      if (!localStorage.getItem("token")) {
        localStorage.setItem("orderMsg", JSON.stringify(orderMsg));
        Message.error("please log in first");
        setTimeout(() => {
          this.$router.push("/en/login");
        }, 800);
        return;
      }

      const type = this.orderType;
      const num = this.selectedNum;
      this.MembershipSubscription(type, num);
    },

    MembershipSubscription(type, num) {
      this.btnDisabled = true;
      let postData = {
        orderType: type,
        num: num,
        // staffName: this.staffName  //姓名不传
      };
      paypal(postData).then((res) => {
        if (res.status == 0) {
          if (res.data) {
            this.btnDisabled = false;
            window.location.href = res.data;
          }
        } else {
          this.$message.error(res.message)
          if(res.message == 'Login information has expired, please log in again.'){
            this.$router.push("/en/login");
          }
          this.btnDisabled = false;
        }
      });
      // VipSubscribe(postData).then((res) => {
      //   if (res.code === 200) {
      //     // 创建一个新的 div 元素来插入表单
      //     const formDiv = document.createElement("div");
      //     formDiv.innerHTML = res.data.buyFormHtml;
      //     console.log(res.data)
      //     document.body.appendChild(formDiv);
      //     // 自动提交表单
      //     const form = formDiv.querySelector("form");
      //     if (form) {
      //       form.submit();
      //     }
      //   } else {
      //     console.error("Subscription failed", res.message);
      //   }
      // });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/software.scss";
@import "@/styles/optimize_adaptation.scss";
.disableBtn {
  opacity: 0.4;
  cursor: default !important;
}
.hiddenImg {
  opacity: 0;
}
.my_software .disableBtn:hover {
  background-color: #343334;
}
</style>
